import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { PersistPartial } from 'redux-persist/es/persistReducer';
import toastSlice from "./features/toast/toastSlice";
import authSlice from "./features/auth/authSlice";

export interface RootState {
  toast: ReturnType<typeof toastSlice>;
  auth: PersistPartial & ReturnType<typeof authSlice>;
}

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, authSlice);

const rootReducer = combineReducers({
  toast: toastSlice,
  auth: persistedReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});

export const persistor = persistStore(store);
